import { render, staticRenderFns } from "./card-loyalty.vue?vue&type=template&id=4645b71c"
import script from "./card-loyalty.ts?vue&type=script&lang=ts&external"
export * from "./card-loyalty.ts?vue&type=script&lang=ts&external"
import style0 from "./card-loyalty.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports